export default function getTourV2DepartureDisplayPrice(
  option: App.Tours.TourV2OfferPurchasableOption,
  displayMemberPrice: boolean,
): number {
  return option.bundledPrice ?? (displayMemberPrice && option.memberPrice ? option.memberPrice : option.price)
}
